import { render, staticRenderFns } from "./decorationBlock.vue?vue&type=template&id=dfb7851e&"
import script from "./decorationBlock.vue?vue&type=script&lang=js&"
export * from "./decorationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports